import Markdown from 'react-markdown'
import { StepIndicator, StepWrapper, Wrapper } from './csSteps.styles'
import Typography from '@/ui/components/typography'

const steps = [
    'In your **Crowdstrike** Falcon account, go to **Menu** -> **Support and Resources** -> **API clients and keys**',
    'Click **Create API client**',
    'Provide a name and description for the API client, for example “At-Bay Client”',
    'Select the 3 **Read Only** requested permissions:' +
        '\n\n**Hosts: Read** ' +
        '\n\n**Zero Trust Assessment: Read**' +
        '\n\n**Sensor Update policies: Read**' +
        '\n\nStance will only monitor information and alert in cases where there are security risks. \n\nClick **Create**',
    'Copy the **Client ID**, **Secret**, and **Base URL** and paste in the inputs below',
    'Click **Enable Integration**. All set! Initial scan will proceed, and the results will appear shortly after',
]

const CsSteps = () => {
    return (
        <Wrapper>
            {steps.map((step, index) => (
                <StepWrapper key={step}>
                    <div>
                        <StepIndicator component="span" variant="xs-bold">
                            {index + 1}
                        </StepIndicator>
                    </div>
                    <Typography component="span" variant="xs-regular">
                        <Markdown>{step}</Markdown>
                    </Typography>
                </StepWrapper>
            ))}
        </Wrapper>
    )
}

export default CsSteps
